import { render, staticRenderFns } from "./AddContact.vue?vue&type=template&id=c9f72a50&scoped=true"
import script from "./AddContact.vue?vue&type=script&lang=js"
export * from "./AddContact.vue?vue&type=script&lang=js"
import style0 from "./AddContact.vue?vue&type=style&index=0&id=c9f72a50&prod&scoped=true&lang=css"
import style1 from "./AddContact.vue?vue&type=style&index=1&id=c9f72a50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f72a50",
  null
  
)

export default component.exports